enum astrologer {
  SUCCESS = 'ASTROLOGER_SUCCESS',
  FAKE = 'ASTROLOGER_FAKE'
}

export default astrologer;
